import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import ModalAlert from '../../components/ModalAlert';
import PaymentConfirmationPanel from '../../components/PaymentConfirmationPanel/PaymentConfirmationPanel'
import fetch from '../../core/fetch';
import cx from 'classnames';
import Select from 'react-select';
import s from './EserviceSummary.css';
import _ from 'lodash';
import waiting from './waiting-wheel-300x300.gif';
import { connect } from 'react-redux';
import { countAction, fetchStatus, trackEvent } from '../../lib/utils';
import { isMobileView, isTabletView, loadingTitle, loadingBody, paymentLoadingTitle, paymentLoadingBody } from '../../components/utils/utils'

const isBrowser = typeof window !== 'undefined' && window !== null;

const alignRight = {
  textAlign: 'right',
  width: '30%',
};

const servicesWithOnlyApplication = [
  'DecyzjaSrodowiskowa',
  'ZaswiadczenieEMUIA',
  'DecyzjaOWarunkachZabudowy',
];

const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
  marginRight: '15px',
};

const noEpuapText = 'Brak adresu skrytki ePUAP. Przejdź do profilu użytkownika (zakładka MOJE DANE) i uzupełnij informacje.';
const noEdoreczeniaText = 'Brak adresu eDoręczeń. Przejdź do profilu użytkownika (zakładka MOJE DANE) i uzupełnij informacje.';


class EserviceSummary extends React.Component {
  calculateCost = () => {
    let totalCost = 0;
    this.props.claim.documents.forEach(element => {
      totalCost = parseFloat(element.cost) + parseFloat(totalCost);
    });
    return totalCost.toFixed(2);
  };

  state = {
    isMounted: false,
    errorTitle: null,
    errorText: null,
    showError: false,
    paymentStatus: this.props.claim.paymentStatus,
    deliveryMethod: this.props.delivery_methods[0],
    paymentMethod: _.find(this.props.paymentMethods, (v, i) => {
      if (v.label == 'Płatność elektroniczna') {
        return v;
      }
    }) || this.props.paymentMethods[0],
    epuapAddress: this.props.user.url,
    eDoreczeniaAddress: this.props.user.e_doreczenia_url,
    wasAddressSuggested: false,
    isValidEpuapAddress: true,
    bankAccount: this.props.bankAccounts[0],
    deliveryMethods: this.props.delivery_methods,
    loading: false,
    paymentLoading: false,
    attachments: [
      {
        name: '',
        extension: '',
        data: '',
      }
    ],
    attachmentFromDB: false,
  };

  epuapRegexString = '^[/][a-zA-Z0-9]{3,}[/][a-zA-Z0-9]{3,}';
  epuapRegex = new RegExp(this.epuapRegexString);

  componentDidMount = () => {
    let paymentMethod = _.find(this.props.paymentMethods, (v, i) => {
      if (v.label == 'Płatność elektroniczna') {
        return v;
      }
    }) || this.props.paymentMethods[0];
    if (this.props.claim.paymentMethodLabel) {
      paymentMethod = _.find(this.props.paymentMethods, (v, i) => {
        if (v.label == this.props.claim.paymentMethodLabel) {
          return v;
        }
      });
    }

    let deliveryMethod  = this.props.delivery_methods[0];
    if (this.props.claim.deliveryMethodLabel) {
      deliveryMethod = _.find(this.props.delivery_methods, (v, i) => {
        if (v.label == this.props.claim.deliveryMethodLabel) {
          return v;
        }
      });
    }

    this.setState({ paymentMethod, deliveryMethod, isMounted: true }, () => this.checkSignError());
  };

  checkSignError = () => {
    const url = new URL(window.location);
    const showSignError = url.searchParams.get("showSignError") === "true";

    if (showSignError) {
      url.searchParams.delete("showSignError");
      window.history.replaceState({}, "", url);

      this.onJobFailed();
    }
  }

  onHide = () => this.setState({ showError: !this.state.showError });
  changeEpuapAddress = e =>
    this.setState({ epuapAddress: e.target.value }, this.validateEpuapAddress);

  validateEpuapAddress = () =>
    this.setState({ isValidEpuapAddress: this.epuapRegex.test(this.state.epuapAddress) });

  checkPayableService = () => {
    let payableService = !this.props.eserviceDistrict.disablePayment;
    let docsCost = 0;
    this.props.claim.documents.map((doc) => (
      docsCost += doc.cost
    ));
    if (docsCost > 0) {
      payableService = true;
    } else {
      payableService = false;
    }
    return payableService;
  }

  onChangeAttachments = (attachments, errorMessage, attachmentFromDB) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError, attachmentFromDB });
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments.length) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const payableService = this.checkPayableService();
    if (!this.state.deliveryMethod.id) return false;
    if (payableService && !this.state.paymentMethod.id) return false;

    if (payableService && this.state.paymentMethod.label === 'Przelewem') {
      const hasEmptyAttachment = this.validateAttachmentsContent();
      if (!this.state.attachments.length || hasEmptyAttachment) {
        this.setState({
          errorText: 'W przypadku płatności przelewem obowiązkowe jest dodanie załącznika z potwierdzeniem wykonania przelewu.',
          errorTitle: 'Nie dodano załącznika.',
          showError: true,
        });
        return false;
      }
    }

    if (this.state.deliveryMethod.label == 'Wysyłka EPUAP' && !this.state.epuapAddress) {
      this.setState({
        errorText: noEpuapText,
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return false;
    }
  
    if (this.state.deliveryMethod.label === 'Wysyłka EPUAP' && !this.state.isValidEpuapAddress) {
      this.setState({
        errorText: 'Wprowadzony adres skrytki ePUAP nie jest prawidłowy, prosimy o poprawne wprowadzenie adresu skrytki.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return false;
    }
  
    if (this.state.deliveryMethod.label === 'Wysyłka e-Doręczenia' && !this.state.eDoreczeniaAddress) {
      this.setState({
        errorText: noEdoreczeniaText,
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return false;
    }
  
    return true;
  };

  onJobFailed = () => this.setState({
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
    loading:false,
    paymentLoading: false,
  });

  savePaymentConfirmation = async () => {
    const url = `${process.env.API_URL}/eservices/payment/confirmation/${this.props.claim.jobId}/`;
    const data = {
      attachments: this.state.attachments,
    };
  
    try {
      const r = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      if (r.status === 200) {
        return true;
      }
  
      this.onJobFailed();
      return false;
    } catch (err) {
      this.onJobFailed();
      return false;
    }
  }

  goToSign = async () => {
    const isValid = this.postValidation();
    if (!isValid) return;

    const payableService = this.checkPayableService();
    if (payableService && this.state.paymentMethod.label === 'Przelewem' && !this.state.attachmentFromDB) {
      const attachmentsSaved = await this.savePaymentConfirmation();
      if (!attachmentsSaved) return;
    }

    this.setState({ loading: true }, () => {
      let redirectURL = `${process.env.API_URL}/eservices/signDoc/${this.props.claim.jobId}?deliveryMethod=${this.state.deliveryMethod.id}`;

      if (payableService) {
        redirectURL += `&paymentMethod=${
          this.state.paymentMethod.id}`;
      }
      if (this.state.deliveryMethod.label == 'Wysyłka EPUAP') {
        redirectURL += `&epuapAddress=${encodeURIComponent(this.state.epuapAddress)}`;
      }
      if (this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia') {
        redirectURL += `&eDoreczeniaAddress=${encodeURIComponent(this.state.eDoreczeniaAddress)}`;
      }
      redirectURL += `&bankAccountId=${this.state.bankAccount.id}`;
      countAction(this.props.claim.prefix, 4, 3, this.props.eserviceDistrict.fk_service)
      .then(() => {
        return fetch(redirectURL, {
          method: 'GET',
        });
      })
      .then((response) => {
        if (response.status == 200) {
          return response.json();
        } else {
          throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
        }
      })
      .then((data) => {
        window.location.href = data.redirectURL;
      })
      .catch((error) => {
        this.onJobFailed();
      });
    })
  };

  goToPayment = () => {
    const isValid = this.postValidation();
    if (!isValid) return;

    const payableService =  this.checkPayableService();
    let redirectURL = `${process.env.API_URL}/eservices/jobPayment/${
      this.props.claim.jobId
      }?deliveryMethod=${this.state.deliveryMethod.id}`
    if (payableService) {
      redirectURL += `&paymentMethod=${
        this.state.paymentMethod.id}`;
    }
    if (this.state.deliveryMethod.label == 'Wysyłka EPUAP') {
      redirectURL += `&epuapAddress=${encodeURIComponent(this.state.epuapAddress)}`;
    }
    if (this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia') {
      redirectURL += `&eDoreczeniaAddress=${encodeURIComponent(this.state.eDoreczeniaAddress)}`;
    }
    redirectURL += `&bankAccountId=${this.state.bankAccount.id}`;

    trackEvent({ category: 'payment', action: 'click', name: this.props.eservices[this.props.claim.shortName].title });

    this.setState({ paymentLoading: true }, () => {
      fetch(redirectURL, {
        method: 'GET',
      })
      .then((response) => {
        if (response.status == 200) {
          return response.json();
        } else {
          this.onJobFailed();
        }
      })
      .then((data) => {
        window.location.href = data.redirectURL;
      })
      .catch((error) => {
        this.onJobFailed();
      });
    })
  };

  changeDelivery = e => this.setState({ deliveryMethod: _.find(this.props.delivery_methods, v => v.id == e.target.value) });

  changePayment = (e) => {
    const value = e.target.value;
    this.setState(
      { paymentMethod: _.find(this.props.paymentMethods, v => v.id == value) },
      () => {
        if (this.props.claim.prefix === 'skierniewice' && _.find(this.props.paymentMethods, v => v.id == value).label === 'W kasie urzędu') {
          this.setState(
            {
              deliveryMethods: [_.find(this.props.delivery_methods, v => v.label === 'Odbiór osobisty')],
              deliveryMethod: _.find(this.props.delivery_methods, v => v.label === 'Odbiór osobisty')
            });
        }
        else {
          this.setState({ deliveryMethods: this.props.delivery_methods });
        }
      }
    );
  }
  changeBankAccount = e =>
    this.setState({ paymentMethod: _.find(this.props.bankAccount, v => v.id == e.target.value) });

  renderDocumentsTable = () => (
    <table className="table">
      <thead>
        <tr>
          <th>Nazwa pliku</th>
          <th style={alignRight}>Wysokość opłaty</th>
        </tr>
      </thead>
      <tbody>
        {this.props.claim.documents.map((doc, i) => (
          <tr key={i}>
            <td>{doc.fileName}</td>
            <td style={alignRight}>{doc.cost.toFixed(2)}</td>
          </tr>
        ))}
        {this.props.claim.documents && this.props.claim.documents.length > 0 ? (
          <tr style={{ borderTop: 'solid 2px black' }}>
            <td>Suma</td>
            <td style={alignRight}>{this.calculateCost()}</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );

  renderApplicationTable = () => (
    <table className="table">
      <thead>
        <tr>
          <th>Nazwa pliku</th>
          <th style={alignRight}>Wysokość opłaty</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{this.props.claim.wniosekFileName}</td>
          <td style={{ textAlign: 'right' }}>
            {this.props.eservices[this.props.claim.shortName].cost.toFixed(2)}
          </td>
        </tr>
      </tbody>
    </table>
  );

  pdfData = () => {
    const user = {
      AddressNumber: this.props.user.AddressNumber,
      AddressFlat: this.props.user.AddressFlat,
      AddressStreet: this.props.user.AddressStreet,
      AddressZipCode: this.props.user.AddressZipCode,
      AddressCity: this.props.user.AddressCity,
      FirstName: this.props.user.FirstName,
      LastName: this.props.user.LastName,
    };
    return {
      jobId: this.props.claim.jobId,
      user: user,
      bank: this.state.bankAccount,
      cost: this.calculateCost(),
      urzad: this.props.districts[this.props.claim.prefix]
    };
  }

  getPaymentStatus = paymentMethod => {
    // fetchStatus
    if (!this.state.disablePayment && paymentMethod.fk_method == '3' && this.state.paymentStatus === 'STARTED') {
      setTimeout(() => {
        fetchStatus(this.props.claim.jobId)
          .then(r => {
            if (r.status == 'STARTED') {
              this.getPaymentStatus(paymentMethod);
            } else {
              this.setState({ paymentStatus: r.status });
            }
          })
      }, 1000);
    }
  }

  renderMobilePaymentDetails = (payableService) => {
    return (
      <tbody>
        { payableService ?
          <tr>
              <b>Forma płatności</b>
          </tr>
        : null}
        { payableService ?
          <tr>
            <select
              className="form form-control needsclick"
              value={this.state.paymentMethod.id}
              onChange={e => this.changePayment(e)}
            >
              {this.props.paymentMethods.map((v, i) => (
                <option key={i} value={v.id}>
                  {v.label}
                </option>
              ))}
            </select>
          </tr>
        : null}
        <tr>
          <b>Forma odbioru odpowiedzi na wniosek</b>
        </tr>
        <tr>
          <select
            className="form form-control needsclick"
            value={this.state.deliveryMethod.id}
            onChange={e => this.changeDelivery(e)}
          >
            {this.state.deliveryMethods.map((v, i) => (
              <option key={i} value={v.id}>
                {v.label}
              </option>
            ))}
          </select>
        </tr>

        { payableService && this.state.paymentMethod.label == 'Przelewem' ?
          <tr>
            <td className={s.borderNone}>
              <PaymentConfirmationPanel
                claim={this.props.claim}
                attachments={this.state.attachments}
                onChangeAttachments={this.onChangeAttachments}
                bankAccountName={this.state.bankAccount && this.state.bankAccount.name ? this.state.bankAccount.name : 'brak informacji'}
                bankAccountNumber={this.state.bankAccount && this.state.bankAccount.number ? this.state.bankAccount.number : ''}
              />
            </td>
          </tr>
        : null}

        {this.state.deliveryMethod.label == 'Wysyłka EPUAP' ? (
          <tr>
              <b>Adres skrytki: </b>
          </tr>
        ) : null}
        { this.state.deliveryMethod.label == 'Wysyłka EPUAP' ? (
          <tr>
            <input
                className="form form-control"
                type="text"
                value={this.state.epuapAddress}
                onChange={e => this.changeEpuapAddress(e)}
                style={!this.state.isValidEpuapAddress ? { borderColor: 'red' } : null}
                disabled
              />
              {!this.state.isValidEpuapAddress ? (
                <span style={{ fontSize: '10px', color: 'red' }}>
                  Nieprawidłowy adres skrytki ePUAP
            </span>
              ) : null}
          </tr>)
          : null}
        { this.state.deliveryMethod.label == 'Wysyłka EPUAP' && !this.state.epuapAddress ? (
            <tr>
              <span style={{color: 'red' }}>
                {noEpuapText}
              </span>
            </tr>
            )
          : null}
        {this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia' ? (
          <tr>
              <b>Adres do doręczeń elektronicznych e-Doręczenia: </b>
          </tr>
        ) : null}
        { this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia' ? (
          <tr>
            <input
                className="form form-control"
                type="text"
                value={this.state.eDoreczeniaAddress}
                disabled
              />
          </tr>)
          : null}
        { this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia' && !this.state.eDoreczeniaAddress ? (
            <tr>
              <span style={{color: 'red' }}>
                {noEdoreczeniaText}
              </span>
            </tr>
            )
          : null}
      </tbody>
    )
  }


  renderStandardPaymentDetails = (payableService) => {
    return (
      <tbody>
        { payableService ?
          <tr style={{ height: '50px' }}>
            <td className={s.borderNone} style={{ padding: '17px 8px' }}>
              <b>Forma płatności</b>
            </td>
            <td className={s.borderNone} style={alignRight}>
              <select
                className="form form-control"
                value={this.state.paymentMethod.id}
                onChange={e => this.changePayment(e)}
              >
                {this.props.paymentMethods.map((v, i) => (
                  <option key={i} value={v.id}>
                    {v.label}
                  </option>
                ))}
              </select>
            </td>
          </tr>
        : null}

        { payableService && this.state.paymentMethod.label == 'Przelewem' ?
          <tr>
            <td colSpan={2} className={s.borderNone}>
              <PaymentConfirmationPanel
                claim={this.props.claim}
                attachments={this.state.attachments}
                onChangeAttachments={this.onChangeAttachments}
                bankAccountName={this.state.bankAccount && this.state.bankAccount.name ? this.state.bankAccount.name : 'brak informacji'}
                bankAccountNumber={this.state.bankAccount && this.state.bankAccount.number ? this.state.bankAccount.number : ''}
              />
            </td>
          </tr>
        : null}
        
        <tr>
          <td className={s.borderNone} style={{ padding: '17px 8px' }}>
            <b>Forma odbioru odpowiedzi na wniosek</b>
          </td>
          <td className={s.borderNone} style={alignRight}>
            <select
              className="form form-control"
              value={this.state.deliveryMethod.id}
              onChange={e => this.changeDelivery(e)}
            >
              {this.state.deliveryMethods.map((v, i) => (
                <option key={i} value={v.id}>
                  {v.label}
                </option>
              ))}
            </select>
          </td>
        </tr>
        {this.state.deliveryMethod.label == 'Wysyłka EPUAP' ? (
          <tr style={{ height: '50px' }}>
            <td className={s.borderNone} style={{ padding: '17px 8px' }}>
              <b>Adres skrytki: </b>
            </td>
            <td className={s.borderNone} style={alignRight}>
              <input
                className="form form-control"
                type="text"
                value={this.state.epuapAddress}
                onChange={e => this.changeEpuapAddress(e)}
                style={!this.state.isValidEpuapAddress ? { borderColor: 'red' } : null}
                disabled
              />
              {!this.state.isValidEpuapAddress ? (
                <span style={{ fontSize: '10px', color: 'red' }}>
                  Nieprawidłowy adres skrytki ePUAP
            </span>
              ) : null}
            </td>
          </tr>
        ) : null}
        { this.state.deliveryMethod.label == 'Wysyłka EPUAP' && !this.state.epuapAddress ? (
          <tr>
            <td className={s.borderNone} style={{ textAlign: 'left' }} colSpan={2}>
              <span style={{color: 'red'}}>
                {noEpuapText}
              </span>
            </td>
          </tr>
          )
        : null}

        {this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia' ? (
          <tr style={{ height: '50px' }}>
            <td className={s.borderNone} style={{ padding: '17px 8px' }}>
              <b>Adres do doręczeń elektronicznych e-Doręczenia: </b>
            </td>
            <td className={s.borderNone} style={alignRight}>
              <input
                className="form form-control"
                type="text"
                value={this.state.eDoreczeniaAddress}
                disabled
              />
            </td>
          </tr>
        ) : null}
        { this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia' && !this.state.eDoreczeniaAddress ? (
          <tr>
            <td className={s.borderNone} style={{ textAlign: 'left' }} colSpan={2}>
              <span style={{color: 'red'}}>
                {noEdoreczeniaText}
              </span>
            </td>
          </tr>
          )
        : null}
      </tbody>
    )
  }

  renderPaymentDetails = (payableService, isMobile, isTablet) => {
    return (<table className="table">
      { isMobile || isTablet ?
        this.renderMobilePaymentDetails(payableService) : 
        this.renderStandardPaymentDetails(payableService)
      }
    </table>)
  }

  renderPaymentButtons = () => {
    const disabledConditions = (this.state.deliveryMethod.label == 'Wysyłka EPUAP' && !this.state.epuapAddress) || 
      (this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia' && !this.state.eDoreczeniaAddress);
    if (this.state.paymentStatus === 'waiting') {
      return (
        <button
          className="btn btn-primary pull-right mobile-button"
          onClick={() => this.goToPayment()}
          style={buttonPayStyle}
          disabled={disabledConditions}
        >
          Zapłać
        </button>
      )
    }
    else if (this.state.paymentStatus === 'STARTED') {
      return (
        <button
          disabled
          onClick={() => this.goToSign()}
          className="btn btn-primary pull-right mobile-button"
          style={buttonPayStyle}
        >
          Podpisz i złóż wniosek
        </button>
      )
    }
    else if (this.state.paymentStatus === 'SUCCESS') {
      return (
        <button
          onClick={() => this.goToSign()}
          className="btn btn-primary pull-right mobile-button"
          style={buttonPayStyle}
          disabled={disabledConditions || this.props.claim.isSigned}  
        >
          Podpisz i złóż wniosek
        </button>
      )
    }
  }

  render() {
    const payableService = this.checkPayableService();
    const paymentMethod = _.find(this.props.paymentMethods, v => v.id === this.state.paymentMethod.id);
    if (!this.state.disablePayment && paymentMethod) {
      this.getPaymentStatus(paymentMethod);
    }

    let isMobile = false;
    let isTablet = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
      isTablet = isTabletView(window);
    }

    const disabledConditions = (this.state.deliveryMethod.label == 'Wysyłka EPUAP' && !this.state.epuapAddress) || 
      (this.state.deliveryMethod.label == 'Wysyłka e-Doręczenia' && !this.state.eDoreczeniaAddress);
    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.state.isMounted ? (
            <GrayPanel title="Podsumowanie">
              <h2>Wniosek</h2>

              {/*
                  RENDER SERVICE NAME
              */}
              <p className={s.sectionTitle}>
                <b>Nazwa usługi</b>
              </p>
              <p>{this.props.eservices[this.props.claim.shortName].title}</p>

              {/*
                  RENDER SERVICE PARCELS LIST
              */}
              {this.props.claim.parcels.length > 0 ? (
                <div>
                <p className={s.sectionTitle}>
                  <b>Lista działek:</b>
                </p>
                <p>
                  {this.props.claim.parcels.map((v, i) => <span key={i}>{v.parcel}; </span>)}
              </p>
              </div>) : null}

              {/*
                  RENDER SERVICE DOCUMENTS TABLE
              */}
              {
                payableService ?
                  (_.includes(servicesWithOnlyApplication, this.props.claim.shortName) ?
                    <h2>Opłata za złożenie wniosku</h2> : <h2>Opłata za dokumenty</h2>
                  ) : null
              }
              {
                payableService ?
                  (_.includes(servicesWithOnlyApplication, this.props.claim.shortName)
                    ? this.renderApplicationTable()
                    : this.renderDocumentsTable()
                  ) : null
              }
              {/*
                  RENDER SERVICE DELIVERY AND PAYMENT METHODS
              */}
              {this.renderPaymentDetails(payableService, isMobile, isTablet)}

              <a
                className="btn btn-success pull-left mobile-button"
                target="_blank"
                href={`${process.env.API_URL}/eservices/getJobApplication/${
                  this.props.claim.jobId
                  }`}
                style={buttonPayStyle}
              >
                Pobierz wniosek
              </a>
              {/* zmiany - pierwsza płatność elektroniczna - potem  podpis PZ */}
              {paymentMethod && paymentMethod.fk_method == '3' && payableService ?
                this.renderPaymentButtons()
                :
                <button
                  onClick={() => this.goToSign()}
                  className="btn btn-primary pull-right mobile-button"
                  style={buttonPayStyle}
                  disabled={disabledConditions || this.props.claim.isSigned}
                >
                  Podpisz i złóż wniosek
                </button>}

            </GrayPanel>
          ) : (
              <GrayPanel
                title="Podsumowanie"
                bodyStyle={{
                  textAlign: 'center !important',
                  marginTop: '100px',
                  marginBottom: '100px',
                }}
              >
                <img alt="Loader" src={waiting} />
                <a className="btn btn-success pull-left" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.claim.jobId}`} style={buttonPayStyle}>Pobierz wniosek</a>
                {this.state.paymentMethod.label === 'Przelewem' || this.state.paymentMethod.label === 'W kasie urzędu' || this.state.paymentMethod.label === 'W opłatomacie urzędu' ?
                  <form method="post" target="_blank" action={`${process.env.API_URL}/eservices/jobPaymentPrint/${this.props.claim.jobId}`}>
                    <input
                      hidden type="text"
                      name="jobPaymentData"
                      value={
                        JSON.stringify(this.pdfData())
                      }
                    />
                    <input type="submit" value="Generuj druczek" className="btn btn-danger pull-left" rel="noopener noreferrer" style={buttonPayStyle} />
                  </form>
                  : null
                }
                <button
                  onClick={() => this.goToSign()}
                  className="btn btn-primary pull-right"
                  style={buttonPayStyle}
                  disabled={disabledConditions || this.props.claim.isSigned}
                >
                  Podpisz i złóż wniosek
                </button>
              </GrayPanel>
            )}
          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />
          <ModalAlert
            title={loadingTitle}
            bodyText={loadingBody}
            show={this.state.loading}
            name="loadingModal"
            onHide={this.onHide}
            disableButton
          />
          <ModalAlert
            title={paymentLoadingTitle}
            bodyText={paymentLoadingBody}
            show={this.state.paymentLoading}
            name="loadingModal"
            onHide={this.onHide}
            disableButton
          />
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
  eservices: state.district.eservices
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(EserviceSummary));


// http POST http://ihub2:8000/api/v1.0/paymentMethod label='W kasie urzędu'
// http POST http://ihub2:8000/api/v1.0/paymentMethod label='Przelewem'
// http POST http://ihub2:8000/api/v1.0/paymentMethod label='Płatność elektroniczna'

// http POST http://ihub2:8000/api/v1.0/deliveryMethods teryt=1815033 label='Wysyłka tradycyjna' protonID='23f27f8d-0a9e-47b2-807f-1fb59184dfea'
// http POST http://ihub2:8000/api/v1.0/deliveryMethods teryt=1815033 label='Wysyłka EPUAP' protonID='b9e7a426-8e1d-435e-8b3d-f0e11b4101d0'
// http POST http://ihub2:8000/api/v1.0/deliveryMethods teryt=1815033 label='Odbiór osobisty' protonID='d620cfe0-f272-40cd-9092-8fee0f59400b'



// WEBPACK FOOTER //
// src/routes/eserviceSummary/EserviceSummary.js